export class ChallengeSdkError extends Error {
    code;
    cause;
    constructor(message, code, cause) {
        super(message);
        this.code = code;
        this.cause = cause;
        this.name = "ChallengeSdkError";
    }
}
export function toChallengeError(message, code, cause) {
    if (cause instanceof ChallengeSdkError) {
        return cause;
    }
    return new ChallengeSdkError(message, code, cause);
}
